module.exports = __webpack_public_path__ + "img/BrandMe_IA_FotoCyberpunk_11.1069a317.png";